<p-selectButton [options]="qualityOptions" [(ngModel)]="model" optionLabel="label" optionValue="value"
    (onChange)="onOptionChanged()">
</p-selectButton>